/* eslint-disable react-hooks/exhaustive-deps */
/**
 * ModalProvider
 */
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ModalContext from './modal-context'
import modalParams from './modal-params'

export default function ModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const [content, setContent] = useState({})

  const { t } = useTranslation()

  const open = (obj = {}) => {
    const modalParamsKey = _.get(obj, 'key')
    const params = !_.isEmpty(modalParamsKey) && _.isFunction(_.get(modalParams, modalParamsKey))
      ? modalParams[modalParamsKey]({ ...obj, t })
      : _.pick(
        obj,
        [
          'title',
          'message',
          'html',
          'contentComponent',
          'buttons',
          'infoButton',
          'shouldCloseOnOverlayClick',
          'className',
          'overlayClassName',
          'mini',
        ],
      )
    setContent(params)
    setIsOpen(true)
  }
  const close = () => {
    setIsOpen(false)
  }
  const onRequestClose = () => {
    close()
  }

  useEffect(() => {
    if (!isOpen) {
      setContent({})
    }
  }, [isOpen])

  const state = {
    isOpen,
    open,
    close,
    onRequestClose,
    ...content,
  }

  return (
    <ModalContext.Provider value={state}>
      {children}
    </ModalContext.Provider>
  )
}
